import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext, useMemo } from "react";
import { SubmitEventReport } from "../../../../../../generated/data-contracts";
import { AvisContext } from "../../../../../shared/context";

interface IReportClientEventsFormCheckboxProps {
  allowBlankReport: boolean | undefined;
  bag: FormikProps<SubmitEventReport>;
  disabled: boolean;
}

export function ReportClientEventsFormCheckbox(
  props: IReportClientEventsFormCheckboxProps,
) {
  const { allowBlankReport, bag, disabled } = props;

  const { res } = useContext(AvisContext);

  const value = useMemo(
    () => bag.values["eventNotOccuredPortal"],
    [bag.values],
  );

  const renderCb = useMemo(() => {
    return (
      <DotsCheckbox<SubmitEventReport>
        bag={bag}
        bagField="eventNotOccuredPortal"
        checkboxLabel={res(
          "licensees_LicenseReports_shared_label_EventNotOccured",
        )}
        disabled={disabled}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, value, res]);

  if (!allowBlankReport) return null;

  return <div>{renderCb}</div>;
}
